import ReactGA from 'react-ga4';
import {GA4, UaEventOptions} from 'react-ga4/types/ga4';
import {GOOGLE_ANALYTICS_MEASURMENTID} from '../../../services/config';

interface IPageViewDataProps {
  hitType: string;
  page: string;
  title: string;
}

class GoogleAnalytics {
  private measurementID: string;
  private gaInstance: GA4;

  constructor() {
    this.measurementID = GOOGLE_ANALYTICS_MEASURMENTID;
    this.gaInstance = ReactGA;
    this.initGoogleAnalytics();
  }
  private initGoogleAnalytics() {
    this.gaInstance.initialize(this.measurementID);
  }

  eventGoogleAnalytics(eventInfo: string | UaEventOptions) {
    this.gaInstance.event(eventInfo);
  }
  sendPageView(pageViewData: string | IPageViewDataProps) {
    this.gaInstance.send(pageViewData);
  }
}

export const googleAnalyticsInstance = new GoogleAnalytics();
